<template>
  <section class="bg-primary-subdued w-full p-32 items-center flex flex-col md-1:flex-row">
    <background-checks-illustration
      class="w-[52px] h-[57.75px] md-1:w-[68px] md-1:h-[77px] flex items-left mr-auto mb-16 md-1:mr-32 md-1:mb-0"
    />
    <div>
      <h2 class="text-h1 mb-8">Find the right sitter for your family.</h2>
      <p class="text-body text-grey-body">
        Search caregivers in your area and request background checks directly from their profiles.
      </p>
    </div>
    <poppins-button
      to="/availability/search"
      value="Search sitters"
      size="medium"
      class="max-h-max mr-auto mt-16 md-1:ml-auto md-1:mt-0 md-1:mr-0"
    />
  </section>
</template>

<script lang="ts">
import BackgroundChecksIllustration from '@/graphics/illustrations/BackgroundChecksIllustration.vue';
import Button from '@/components/button/Button.vue';

export default {
  name: 'BGCSearchBanner',
  components: {
    BackgroundChecksIllustration,
    PoppinsButton: Button,
  },
};
</script>
